import { PropertyFilters, PropertyRepository } from "@/repositories/properties.repository";
import {ReadAllResponse} from "@/interfaces";
import {Property} from "@/models/properties.model.ts";

export async function fetchProperties(filters: PropertyFilters): Promise<ReadAllResponse<Property>> {
  return PropertyRepository.getAll(filters);
}

export async function insertProperty(values: Partial<Property>): Promise<Property> {
  return PropertyRepository.create(values);
}